<div class="go-embed">
  <div class="v2-toolbar">
    <mat-spinner *ngIf="loading" diameter="24" class="v2-inline-spin"></mat-spinner>
    <button mat-stroked-button (click)="recomputeAll(true)" [disabled]="recomputingAll || !rows.length"
            matTooltip="Compute Frigg-app and coffee/juice turnover for rows that don't have it yet — nothing runs automatically">
      <mat-icon [class.go-spin]="recomputingAll">refresh</mat-icon> {{ recomputingAll ? 'Recomputing…' : 'Recompute missing' }}
    </button>
    <span class="v2-spacer"></span>
    <button mat-stroked-button (click)="exportXlsx()" [disabled]="!rows.length">
      <mat-icon>table_view</mat-icon> Export (Excel)
    </button>
  </div>

  <div class="v2-empty v2-error" *ngIf="loadError"><mat-icon>error_outline</mat-icon> {{ loadError }}</div>
  <div class="v2-empty v2-error" *ngIf="saveError"><mat-icon>error_outline</mat-icon> {{ saveError }}</div>

  <p class="v2-note">
    Garanti (ex-VAT) is read-only here — it's set per system on the System card, same value the sales-report's
    income-vs-garanti graph uses. Frigg-app achieved turnover is summed on demand from transactions (inc. VAT) —
    use "Recompute missing" below, a row's refresh icon, or "Run reconciliation" on Billing (which triggers it
    automatically). Coffee + juice counts toward the guarantee too: coffee from the Vendon machines linked to the
    system (paid at the machine plus what is invoiced per cup), juice from the Juice tab. Vendor/vending-machine achieved turnover has no automated source and must be entered manually
    from that channel's own report. Food VAT (15%) is applied to achieved sales regardless of the customer's own
    invoice VAT rate.
  </p>
  <div class="v2-empty v2-error" *ngIf="unlinkedCount">
    <mat-icon>link_off</mat-icon>
    {{ unlinkedCount }} system(s) below have no one set to pay the shortfall. Choose "Paid by" for them —
    invoicing stops while one of them has a shortfall to bill.
  </div>

  <div class="v2-empty" *ngIf="!loading && !rows.length">
    <mat-icon>event_busy</mat-icon>
    No systems have a garantiomsetning set for {{ month }}. Set one on a system's card.
  </div>

  <div class="v2-table-wrap" *ngIf="rows.length">
      <table class="v2-plain-table go-table">
        <thead>
          <tr>
            <th>System</th>
            <th>Paid by</th>
            <th class="num">Garanti (ex-VAT)</th>
            <th class="num">% i drift</th>
            <th class="num">Garanti etter %</th>
            <th class="num">Vendor (inc-VAT)</th>
            <th class="num">Frigg app (inc-VAT)</th>
            <th class="num">Coffee + juice (inc-VAT)</th>
            <th class="num">Sum (inc-VAT)</th>
            <th class="num">Sum (ex-VAT)</th>
            <th class="num">Shortfall (ex-VAT)</th>
            <th class="num">Kickback</th>
            <th class="num">Faktureres til kunde</th>
            <th>Status</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let g of groupedRows; trackBy: trackGroup">
            <tr class="go-group-row">
              <td colspan="15">{{ companyName(g.companyId) }}</td>
            </tr>
            <tr *ngFor="let r of g.rows; trackBy: trackRow" [class.go-saving]="r.saving" [class.go-unlinked]="!r.kundekortId">
              <td>{{ r.systemName }}</td>
              <td class="go-payer">
                <ng-container *ngIf="editingPayerFor !== r.systemId; else payerEdit">
                  <span [matTooltip]="payerHint(r)">{{ r.customerName }}</span>
                  <span class="v2-chip go-payer-chip" *ngIf="r.payerSource === 'linked'" [matTooltip]="payerHint(r)">from link</span>
                  <span class="v2-chip v2-chip-warn go-payer-chip" *ngIf="!r.kundekortId" [matTooltip]="payerHint(r)">choose</span>
                  <button mat-icon-button class="go-recompute" (click)="startEditPayer(r)" matTooltip="Choose who pays this system's garantiomsetning">
                    <mat-icon>edit</mat-icon>
                  </button>
                </ng-container>
                <ng-template #payerEdit>
                  <input type="text" class="go-input go-input-payer" placeholder="Search customer…" autofocus
                         [(ngModel)]="payerQuery" (ngModelChange)="filterPayers(r, $event)"
                         (keydown.escape)="cancelEditPayer()" [matAutocomplete]="payerAuto">
                  <mat-autocomplete #payerAuto="matAutocomplete" (optionSelected)="choosePayer(r, $event.option.value)">
                    <mat-option *ngFor="let c of payerOptions" [value]="c.id">
                      {{ c.name }}<span class="go-linked-tag" *ngIf="c.linked"> · linked</span>
                    </mat-option>
                    <mat-option *ngIf="r.payerSource === 'set'" [value]="null">
                      <em>Clear — fall back to the linked customer</em>
                    </mat-option>
                  </mat-autocomplete>
                  <button mat-icon-button class="go-recompute" (click)="cancelEditPayer()" matTooltip="Cancel">
                    <mat-icon>close</mat-icon>
                  </button>
                </ng-template>
              </td>
              <td class="num">
                {{ r.garantiEksMva | number:'1.2-2' }}
                <ng-container *ngIf="editingPeriodFor !== r.systemId; else periodEdit">
                  <span class="v2-chip go-payer-chip" *ngIf="r.periodMonths > 1"
                        [matTooltip]="'Invoiced every ' + r.periodMonths + ' months from ' + r.periodStart">every {{ r.periodMonths }} mo</span>
                  <button mat-icon-button class="go-recompute" (click)="startEditPeriod(r)" matTooltip="How often the shortfall is invoiced">
                    <mat-icon>event_repeat</mat-icon>
                  </button>
                </ng-container>
                <ng-template #periodEdit>
                  <div class="go-period-edit">
                    every
                    <mat-select class="go-select go-select-sm" [(ngModel)]="periodDraft.months">
                      <mat-option *ngFor="let n of [1, 2, 3, 4, 6, 12]" [value]="n">{{ n === 1 ? '1 month' : n + ' months' }}</mat-option>
                    </mat-select>
                    <ng-container *ngIf="periodDraft.months > 1">
                      from <input type="month" class="go-input" [(ngModel)]="periodDraft.start">
                    </ng-container>
                    <button mat-icon-button class="go-recompute" (click)="savePeriod(r)" matTooltip="Save"><mat-icon>check</mat-icon></button>
                    <button mat-icon-button class="go-recompute" (click)="cancelEditPeriod()" matTooltip="Cancel"><mat-icon>close</mat-icon></button>
                  </div>
                </ng-template>
              </td>
              <td class="num">
                <input type="number" class="go-input go-input-sm" min="0" max="1" step="0.01"
                       [(ngModel)]="r.prosentIDrift" (change)="onFieldChange(r)"
                       matTooltip="Fraction of the month in operation, e.g. 0.75 for reduced days">
              </td>
              <td class="num">{{ garantiAfterProsent(r) | number:'1.2-2' }}</td>
              <td class="num">
                <input type="number" class="go-input" min="0" step="1"
                       [(ngModel)]="r.vendorAchievedIncVat" (change)="onFieldChange(r)">
              </td>
              <td class="num go-computed">
                {{ r.friggAppAchievedIncVat | number:'1.2-2' }}
                <button mat-icon-button class="go-recompute" [disabled]="r.computing" (click)="recompute(r)"
                        matTooltip="Recompute from transactions">
                  <mat-icon [class.go-spin]="r.computing">refresh</mat-icon>
                </button>
              </td>
              <td class="num go-computed" [matTooltip]="r.coffeeJuiceDetail || 'Not computed yet — use the refresh icon'" matTooltipClass="go-pre-tooltip">
                {{ r.coffeeJuiceAchievedIncVat | number:'1.2-2' }}
              </td>
              <td class="num">{{ sumAchievedIncVat(r) | number:'1.2-2' }}</td>
              <td class="num">{{ sumAchievedExVat(r) | number:'1.2-2' }}</td>
              <td class="num" [class.go-neg]="shortfallExVat(r) < 0">{{ shortfallExVat(r) | number:'1.2-2' }}</td>
              <td class="num">{{ r.kickbackRate ? (kickbackAmount(r) | number:'1.2-2') : '—' }}</td>
              <td class="num" *ngIf="!r.periodNote"><strong [class.go-neg]="netToInvoice(r) < 0">{{ netToInvoice(r) | number:'1.2-2' }}</strong></td>
              <td class="num go-period-note" *ngIf="r.periodNote" [matTooltip]="r.periodNote">{{ r.periodNote.startsWith('Invoiced') ? 'period, see invoice' : 'next: ' + r.periodNote.slice(-7) }}</td>
              <td>
                <mat-select class="go-select" [(ngModel)]="r.status" (selectionChange)="onFieldChange(r)">
                  <mat-option value="">—</mat-option>
                  <mat-option *ngFor="let s of statuses" [value]="s">{{ s }}</mat-option>
                </mat-select>
              </td>
              <td>
                <input type="text" class="go-input go-input-note" [(ngModel)]="r.note" (change)="onFieldChange(r)">
              </td>
            </tr>
          </ng-container>
          <tr class="v2-invoice-total">
            <td>Total</td>
            <td></td>
            <td class="num">{{ totalGaranti | number:'1.2-2' }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="num">{{ totalAchievedExVat | number:'1.2-2' }}</td>
            <td></td>
            <td></td>
            <td class="num"><strong>{{ totalBillable | number:'1.2-2' }}</strong></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
  </div>
</div>
